import { useAuth0 } from "@auth0/auth0-react";
import {
  Button,
  Stack,
  Typography,
  useTheme
} from "@mui/material";
import React from "react";
import { useEnvConfig } from "rwo-react";
import { PageLayout } from "../components/PageLayout";


export const RootPage: React.FC = () => {

  const theme = useTheme();
  const { logout } = useAuth0();
  const { clientId, redirectUri } = useEnvConfig();

  const logoutOptions = {
    logoutParams: {
      clientId: clientId,
      federated: true,
      returnTo: redirectUri
    }
  }

  return (
    <PageLayout>
      <Stack pb={{ xs: 8, md: 12 }} spacing={{ xs: 2, md: 2 }}>
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: 24,
            color: theme.colors.text[5],
            display: "block",
            mb: 0,
          }}
        >
          Welcome to the SSO Test Application
          <br />
          <Button color="primary" onClick={() => void logout(logoutOptions)} variant="contained">
            Logout
          </Button>
        </Typography>

      </Stack>
    </PageLayout >
  );
};
